module.exports = __webpack_public_path__ + "static/media/summer_campaign_banner.094cb551.png";